<template>

  <modal id="detalhes-registro-titulo" class="modal-detalhes-entidade" :titulo="titulo" :loading="loading" :check="registroValido">
    <template #title-extra>
      <div v-if="ficha && ficha.status !== 'ABERTA'" class="badge text-center" :class="classStatus">
        {{ficha.status}}
      </div>
    </template>
    <template #actions>

      <template v-if="!$root.isAuditorOnly && ficha.status != 'PENDENTE'">

        <li class="list-inline-item" :class="{active : aba == 'anexos'}" >
          <a @click.prevent="aba = 'anexos'" title="Documentação & Anexos" href>
            <i class="fal fa-paperclip"></i>
          </a>
        </li>

        <li class="list-inline-item" :class="{active : aba == 'historico'}">
          <a @click.prevent="aba = 'historico'" title="Histórico" href>
            <i class="fas fa-history"></i>
          </a>
        </li>

      </template>

        <li class="list-inline-item">
          <router-link :to="{ name: 'digitalizacao', params: { id: id, entidade : 'INDICADOR', tipoEntidade : livro }}" target="_blank" title="Digitalização">
            <i class="fal fa-file-image"></i>
          </router-link>
        </li>

      <template v-if="!$root.isAuditorOnly && ficha.status != 'PENDENTE'">

        <li class="list-inline-item">
          <a @click.prevent.stop="imprimir(ficha)" title="Imprimir" href>
            <i class="fal fa-print"></i>
          </a>
        </li>

      </template>

      <li class="list-inline-item" v-if="!$root.isAuditorOnly">
        <a @click.prevent.stop="editarIndicador(ficha)" title="Editar Indicador"  href>
          <i class="fal fa-edit"></i>
        </a>
      </li>

    </template>

    <template #header>

      <ul class="nav nav-tabs">

        <template  v-for="a in abas">
          <li class="nav-item" :key="a.id" v-if="a.exibir">
            <a @click.prevent="aba = a.id" :title="a.title" class="nav-link py-1 px-2 small"
               href :class="{'active' : aba == a.id}">
              {{a.nome}}
            </a>
          </li>
        </template>

      </ul>

    </template>

    <template v-if="ficha.id">
      <template v-if="!$root.isAuditorOnly">

        <template v-for="(alerta, index) in alertas" >
          <AlertBanner v-if="alerta.mostrar" :key="index" :message="alerta.msg"/>
        </template>

        <alert-ocorrencia :indicador="ficha.id" tipo="alert-banner" :banner="ocorrenciaBloqueante ? 'alert-danger' : 'alert-warning'" />

      </template>

      <template v-if="this.componente === 'aba-atos' && ficha.textoLegado " >
        <a @click.prevent="vizualizarTextoLegado(ficha)" title="Vizualizar Texto" href>
          <AlertBanner message="Registro de título possui um texto importado!"/>
        </a>
      </template>

    </template>

    <component v-if="!loading && livro && aba" :is="componente" :ficha="ficha" :id="ficha.id" :livro="livro" v-bind="aba === 'atos' && ficha.status === 'PENDENTE' ? { somenteLeitura: true, permiteAdicionarAto: true, permiteAcoesRegistro: true } : {}" @load="load"/>
    <template #footer v-if="permitirExcluir && aba == 'dados'">
      <v-button :run="excluir" :popover="true" position="dropupleft" class="btn btn-outline-danger ml-auto">Excluir</v-button>
    </template>
  </modal>

</template>

<script>

  import AuditorBusiness from "@/business/AuditorBusiness.js";
  import FrontBusiness from "@/business/FrontBusiness";
  import RegistroTDBusiness from "@/business/indicadores/RegistroTDBusiness.js";
  import RegrasEstaduaisBusiness from "@/business/RegrasEstaduaisBusiness.js";
  import AlertBanner from "@/components/alert/AlertBanner";
  import AlertOcorrencia from "@/components/alert/AlertOcorrencia.vue";
  import AlertMessage from "@/components/alert/AlertConstMessage";
  import ImprimirFicha from "@/components/Livros/ImprimirFicha.vue";
  import Modal from "@/components/Modal";
  import Anexos from "@/components/IndicadorGeneric/Detalhes/Anexos";
  import Atos from "@/components/IndicadorGeneric/Detalhes/Atos.vue";
  import Historico from "@/components/IndicadorGeneric/Detalhes/Historico.vue";
  import Ocorrencias from "@/components/IndicadorGeneric/Detalhes/Ocorrencias.vue";
  import Protocolos from "@/components/IndicadorGeneric/Detalhes/Protocolos.vue";
  import Dados from "@/components/RegistroTitulo/Detalhes/Dados";
  import FormRegistroTD from "@/components/RegistroTitulo/Form/FormRegistroTD.vue";
  import TextoLegado from "@/views/Protocolo/Atos/TextoLegado";
  import OcorrenciaBusiness from "@/business/ocorrencia/OcorrenciaBusiness";
  import EventBus from "@/commons/EventBus";

  export default {

    name: "DetalhesRegistroTD",
    components: {
      Modal,
      AlertBanner,
      AlertOcorrencia,
      "aba-dados" : Dados,
      "aba-atos" : Atos,
      "aba-historico" : Historico,
      "aba-anexos" : Anexos,
      "aba-protocolos" : Protocolos,
      "aba-ocorrencias" : Ocorrencias,
      "aba-registros-posteriores" : () => import("@/components/IndicadorGeneric/Detalhes/RegistrosPosteriores")
    },

    props: {
      id : String,
      abaInicial: String
    },

    modal: {
      width: 900
    },

    async created(){
        await this.load();
        EventBus.$on('ATOS-LOAD', this.load);
    },

    computed:{
      titulo(){
        return this.ficha?.livro ? FrontBusiness.nomearFicha(this.ficha) : '';
      },
      livro(){
        return this.ficha?.livro;
      },
      componente(){
        return `aba-${this.aba}`;
      },
      alertas() {
          return [
              {mostrar: this.protocolosAtivos, msg: AlertMessage.indicadorPossuiProtocolos()}
          ];
      },

      usuario() {
        return this.$root.usuarioLogado;
      },

      /* FIXME: Migrar para IndicadorBusiness.classStatus(). */
      classStatus() {
        if (this.ficha.status == 'ENCERRADA') {
          return 'badge-primary-soft';
        } else if (this.ficha.status == 'CANCELADA') {
          return 'badge-danger-soft';
        } else if (this.ficha.status == 'ANULADA') {
          return 'badge-danger-soft';
        } else if (this.ficha.status == 'INEXISTENTE') {
          return 'badge-secondary-soft';
        } else if (this.ficha.status == 'BLOQUEADA') {
          return 'badge-warning-soft';
        }
        return 'badge-success-soft'
      }
    },

    data() {
      return {
        ficha : {},
        aba : 'dados',
        protocolosAtivos: false,
        ocorrenciaBloqueante: false,
        registroValido: false,
        abas:[],
        loading: true,
        permitirExcluir: true
      }
    },

    methods:{

      showError(e) {
        FrontBusiness.fullErrorHandler(this, e);
      },

      async load(loading = true){
        this.loading = loading;
        this.ficha = await RegistroTDBusiness.getById(this.id);

        let protocolos = [];
        let exibeAbaAtosPreRegistro = false;
        const auditor = this.$root.isAuditorOnly;

        await Promise.all([
          !auditor ? RegistroTDBusiness.buscarProtocolosAtivos(this.ficha.id).then(r => protocolos = r) : null,
          this.registroTituloValidado(),
          RegrasEstaduaisBusiness.exibeAbaAtosPreRegistroRtdRcpj().then(r => exibeAbaAtosPreRegistro = r)
        ]);

        this.protocolosAtivos = protocolos.length > 0;

        let isPendente = this.ficha.status == 'PENDENTE';

        let abaVisivel = (perm) => AuditorBusiness.abaVisivel(perm);
        let exibirAba = (perm) => AuditorBusiness.exibirAba(perm, this.preview);

        this.abas = [
          {id: 'dados', nome: 'Dados', exibir: abaVisivel('AUDITOR_ABA_DADOS_RT'), title: 'Dados Principais'},
          {id: 'atos', nome: 'Atos Registrados', exibir: !this.preview && (!isPendente || exibeAbaAtosPreRegistro) && abaVisivel('AUDITOR_ABA_ATOS_REGISTRADOS_RT'), title: 'Atos Registrados'},
          {id: 'registros-posteriores', nome: 'Registros Posteriores', exibir: abaVisivel('AUDITOR_ABA_REGISTROS_POSTERIORES_RT'), title: 'Registros Posteriores'},
          {id: 'protocolos', nome: 'Protocolos', exibir: exibirAba('AUDITOR_ABA_PROTOCOLOS_RT')},
          {id: 'ocorrencias', nome: 'Ocorrências', exibir: exibirAba('AUDITOR_ABA_OCORRENCIAS_RT')}
        ];

        if (this.abaInicial) {
          this.$set(this, 'aba', this.abaInicial);
        }

        if (this.$root.isAuditorOnly) {
          const abasVisiveis = this.abas.filter(a => a.exibir);
          const abaAtualValida = abasVisiveis.some(a => a.id === this.aba);
          if (!abaAtualValida) {
            this.$set(this, 'aba', abasVisiveis.length > 0 ? abasVisiveis[0].id : null);
          }
        }

        this.$set(this, 'permitirExcluir', this.ficha.status != 'PENDENTE' && this.$root.getPermission({id: 'PERMITIR_EXCLUIR_INDICADOR_RTD'}));

        this.$set(this, 'loading', false);
        this.possuiOcorrenciasBloqueantes();
      },

      async possuiOcorrenciasBloqueantes(){
        this.ocorrenciaBloqueante = await OcorrenciaBusiness.possuiOcorrenciasBloqueantes(this.ficha.id);
      },

      async editarIndicador(ficha) {
          let result = await FrontBusiness.openModal(FormRegistroTD, {id: ficha.id, livro: ficha.livro});
          if(result){
              this.$set(this, 'ficha', null);
              await this.load();
          }
      },

      imprimir(ficha){
        FrontBusiness.openModal(ImprimirFicha, {id: ficha.id, tipo: 'REGISTRO_TD', codigo: ficha.codigo});
      },

      async vizualizarTextoLegado(ficha){
        let retorno = await FrontBusiness.openModal(TextoLegado, {ficha: ficha, tipo: "REGISTRO_TD"});
        if (retorno) {
          this.ficha = retorno;
        }
      },

      async registroTituloValidado(){
        this.registroValido = await RegistroTDBusiness.indicadorValidado(this.ficha.id);
      },

      async excluir(){
        if (this.permitirExcluir) {
          let retorno = await RegistroTDBusiness.delete(this.ficha.id).catch(this.showError);
          if (retorno) {
            FrontBusiness.closeModal();
          }
        }
      },

    }

  }
</script>
